import { motion } from 'framer-motion';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

const Card = ({
    children,
    className = '',
    hover = true,
    as = 'div',
    ...props
}) => {
    const Component = motion[as] || motion.div;

    const baseStyles = 'overflow-hidden bg-white/[0.03] border border-white/[0.08] backdrop-blur-xl rounded-[12px]';

    const hoverStyles = hover ? 'hover:bg-white/[0.06] hover:shadow-glow-blue' : '';

    const classes = twMerge(clsx(baseStyles, hoverStyles, className));

    return (
        <Component
            className={classes}
            whileHover={hover ? { y: -4, transition: { duration: 0.3 } } : {}}
            transition={{ duration: 0.3 }}
            {...props}
        >
            {children}
        </Component>
    );
};

export default Card;
